import {HTTP} from '@/CallAPI'
export default {
  getListPosition (page, perPage = '', status = '') {
    return HTTP.get('positions', {params: {
      page: page,
      per_page: perPage,
      status: status
    }})
  },

  createPosition (position) {
    return HTTP.post('positions', position)
  },

  showPosition (position) {
    return HTTP.get('positions/' + position.id)
  },

  updatePosition (position) {
    return HTTP.put('positions/' + position.id, position)
  },

  destroyPosition (position) {
    return HTTP.delete('positions/' + position.id)
  },

  rejectPosition (position) {
    return HTTP.post('positions/' + position.id + '/rejection')
  },

  approvalPosition (position) {
    return HTTP.post('positions/' + position.id + '/approval')
  }
}



// WEBPACK FOOTER //
// ./src/service/position.js